/** @file Maps 2D points (plus optional offsets) through one world affine block into a Float32Array. */

/**
 * Writes `count` points `world · (src + deform)` (2 numbers per point; `deform` null = no offsets) into `out` at
 * `offset`, reading the affine [a, b, c, d, tx, ty] at `world[worldOffset]`; returns offset + 2·count.
 */
export function writeWorldPoints(out: Float32Array, offset: number, src: ArrayLike<number>, deform: ArrayLike<number> | null, count: number, world: ArrayLike<number>, worldOffset: number): number {
  const a = world[worldOffset] ?? 0, b = world[worldOffset + 1] ?? 0, c = world[worldOffset + 2] ?? 0;
  const d = world[worldOffset + 3] ?? 0, tx = world[worldOffset + 4] ?? 0, ty = world[worldOffset + 5] ?? 0;
  for (let k = 0; k < 2 * count; k += 2) {
    const x = (src[k] ?? 0) + (deform === null ? 0 : (deform[k] ?? 0));
    const y = (src[k + 1] ?? 0) + (deform === null ? 0 : (deform[k + 1] ?? 0));
    out[offset + k] = a * x + b * y + tx;
    out[offset + k + 1] = c * x + d * y + ty;
  }
  return offset + 2 * count;
}
